@if (orderHistoryResult$ | async; as orderHistoryResult) {
  <div class="results-section" role="region" aria-labelledby="results-heading"
    >
    @if (sorts$ | async; as sorts) {
      <div class="results-header">
        @if (paginate$ | async; as paginate) {
          <div class="results-info" id="results-heading">
            {{ 'orderHistory.showingDetail' | cxTranslate:{ current: orderHistoryResult.length, total:
            paginate.totalResults} }}
          </div>
        }
        <div class="results-actions">
          <label class="sort-label" for="sort-select">SORT BY</label>
          <cx-sorting id="sort-select" class="sort-select" [sortOptions]="sorts" container="body" class="sort-by-search"
            [sortLabels]="getSortLabels() | async" (sortListEvent)="changeSortCode($event)" [selectedOption]="sortType"
            [placeholder]="'orderHistory.sortByMostRecent' | cxTranslate">
          </cx-sorting>
          <button type="button" [disabled]="downloadProgress" class="download-btn"
            (click)="downloadOrders('orders', 'Orders', true, 'Orders_Export')">
            {{ 'invoiceResult.download' | cxTranslate }} &nbsp;
            <!-- <i class="fas fa-download" aria-hidden="true"></i> -->
          </button>
        </div>
      </div>
    }
    @if (orderHistoryResult && orderHistoryResult.length) {
      <div role="region" aria-label="Orders table" tabindex="0" class="orders-table ">
        <table class="returns-table" role="table" aria-label="Order history data">
          <thead>
            <tr role="row">
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.orderNumber' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.brand' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.purchaseOrderNumber' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.accountNumber' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.accountName' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.status' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.orderDate' | cxTranslate }} <br> {{ 'orderHistoryResult.header.creationDate' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.orderValue' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.creditStatus' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.deliveryBlock' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.orderType' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.jobName' | cxTranslate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (order of orderHistoryResult; track order) {
              <tr role="row"
                (click)=" redirectToDetail(order)"
                [ngClass]="{'cursor-not-allowed': order.deliveryBlock === 'Processing'}">
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.orderNumber' | cxTranslate">
                  <a href="javascript:void(0)" class="rma-link">{{ order.code | removeLeadingZeros }}</a>
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.brand' | cxTranslate">
                  {{ order.brandName ? order.brandName : '-' }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.purchaseOrderNumber' | cxTranslate">
                  {{ order.purchaseOrderNumber ? order.purchaseOrderNumber : '-' }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.accountNumber' | cxTranslate">
                  {{ order.accountNumber | removeLeadingZeros }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.accountName' | cxTranslate">
                  {{ order.accountName }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.status' | cxTranslate">
                  {{ order.statusDisplay ? order.statusDisplay : '-'  }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.orderDate' | cxTranslate">
                  <!-- {{ order.orderDate ? order.orderDate : '-' }} -->
                  <span>{{ order.creationDate ? order.creationDate : '-' }}</span>
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.orderValue' | cxTranslate">
                  {{ order?.total?.formattedValue ?  order?.total?.formattedValue : '-' }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.creditStatus' | cxTranslate">
                  {{ order.creditStatus ? order.creditStatus : '-' }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.deliveryBlock' | cxTranslate">
                  {{ order.deliveryBlock ? order.deliveryBlock : '-' }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.orderType' | cxTranslate">
                  {{ order.orderType ? order.orderType : '-' }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.jobName' | cxTranslate">
                  {{ order.jobName ? order.jobName : '-' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @if (paginate$ | async; as paginate) {
      <div class="show-more-container">
        @if (paginate.currentPage < paginate.totalPages - 1 && (isLoader$ | async)===false) {
          <button class="show-more-btn"
            (click)="loadMore(paginate.currentPage)">
            {{ 'orderHistoryResult.showMore' | cxTranslate }}
          </button>
        }
      </div>
    }
    @if (orderHistoryResult && orderHistoryResult.length < 1 && (isLoader$ | async)===false) {
      <div class="alert-info p-3 rounded mt-3"
        >
        {{ 'orderHistoryResult.nodataMsg' | cxTranslate }}
      </div>
    }
  </div>
}